// Models
import { RecurrenceEndType } from "../../../service/planner/enumerations/IPlannerEnumerations";
import { RecurrencePattern } from "./RecurrencePattern";
import { RecurrenceRange } from "./RecurrenceRange";
// Utilities
import { Temporal } from "temporal-polyfill-lite";
import { getDiff, getDiffTemporalAndArrayCustomizer } from "@ms/uno-utilities/lib/local/ObjectUtilities";
import isEmpty from "lodash/isEmpty";
/**
 * The recurrence schedule implementation.
 */ export class RecurrenceSchedule {
    static fromResource(resource) {
        return new RecurrenceSchedule({
            pattern: RecurrencePattern.fromResource(resource.pattern),
            // range: RecurrenceRange.fromResource(resource.range),
            range: RecurrenceRange.fromResource({
                recurrenceEndType: RecurrenceEndType.EndOfPlan,
                endDate: null,
                countOfInstances: null,
                startDate: resource.patternStartDateTime
            }),
            nextOccurrenceDateTime: !isEmpty(resource.nextOccurrenceDateTime) ? Temporal.Instant.from(resource.nextOccurrenceDateTime) : null
        });
    }
    getClone() {
        return new RecurrenceSchedule({
            pattern: this.pattern.getClone(),
            range: this.range.getClone(),
            nextOccurrenceDateTime: this.nextOccurrenceDateTime != null ? Temporal.Instant.from(this.nextOccurrenceDateTime) : null
        });
    }
    forSerialization() {
        return {
            pattern: this.pattern.forSerialization(),
            // range: this.range.forSerialization(),
            patternStartDateTime: this.range.forSerialization().startDate,
            nextOccurrenceDateTime: this.nextOccurrenceDateTime?.toString() ?? ""
        };
    }
    forCreate() {
        return {
            pattern: this.pattern.forSerialization(),
            // range: this.range.forSerialization(),
            patternStartDateTime: this.range.forSerialization().startDate
        };
    }
    forUpdate(source) {
        // Use getDiff to get the differences between current and source entity
        const diff = getDiff(source, this, getDiffTemporalAndArrayCustomizer);
        // If no differences found, return undefined
        if (isEmpty(diff)) {
            return undefined;
        }
        const resource = {};
        if (diff.pattern) {
            // Pattern is immutable on the service. The entire object has to be sent when changed.
            resource.pattern = this.pattern.forSerialization();
        }
        if (diff.range) {
            // Range is immutable on the service. The entire object has to be sent when changed.
            // resource.range = this.range.forSerialization();
            resource.patternStartDateTime = this.range.forSerialization().startDate;
        }
        if (!isEmpty(resource)) {
            return resource;
        }
    }
    setRecurrencePattern(pattern) {
        return new RecurrenceSchedule({
            pattern,
            range: this.range.getClone(),
            nextOccurrenceDateTime: this.nextOccurrenceDateTime != null ? Temporal.Instant.from(this.nextOccurrenceDateTime) : null
        });
    }
    setRecurrenceRange(range) {
        return new RecurrenceSchedule({
            pattern: this.pattern.getClone(),
            range,
            nextOccurrenceDateTime: this.nextOccurrenceDateTime != null ? Temporal.Instant.from(this.nextOccurrenceDateTime) : null
        });
    }
    generateHash() {
        return [
            this.pattern.generateHash(),
            this.range.generateHash(),
            this.nextOccurrenceDateTime?.toString() ?? ""
        ].join(",");
    }
    constructor(propertyBag){
        this.pattern = propertyBag.pattern;
        this.range = propertyBag.range;
        this.nextOccurrenceDateTime = propertyBag.nextOccurrenceDateTime;
    }
}
